import temml from 'temml';

import { logger } from '@zep/core-logger';

import { escapeHtml } from './escapeHtml';
import { normalizeMathliveLatex } from './normalizeMathliveLatex';

// 동일 LaTeX 입력의 반복 보고를 차단하기 위한 모듈 단위 dedup. AI 결과
// 카드처럼 같은 입력이 여러 번 렌더되는 경우 Sentry/Hyperdx에 중복 리포트가
// 쌓이지 않도록 한다.
const reportedLatex = new Set<string>();

/**
 * Render a LaTeX string to MathML via Temml.
 *
 * `throwOnError: true`로 두어 파싱 실패 시 catch에서 폴백 문자열(`$...$` /
 * `$$...$$`)로 회복하며, 원본 LaTeX과 함께 logger로 1회 보고한다. 폴백을
 * string으로 반환하므로 throw가 React render 트리로 전파되지 않아 global
 * error boundary는 작동하지 않는다.
 *
 * 반환값은 호출처에서 `dangerouslySetInnerHTML`로 주입되므로, 폴백 경로의
 * raw LaTeX은 escape하여 `<script>` 같은 페이로드가 DOM으로 새지 않도록 한다.
 */
export const renderLatexToMathML = (
  latex: string,
  displayMode = false,
): string => {
  try {
    return temml.renderToString(normalizeMathliveLatex(latex), {
      displayMode,
      throwOnError: true,
      annotate: true,
    });
  } catch (e) {
    if (!reportedLatex.has(latex)) {
      reportedLatex.add(latex);
      logger.captureError(e, {
        fingerprint: ['latex-renderer'],
        extra: { latex, displayMode },
      });
    }
    const safe = escapeHtml(latex);
    return displayMode ? `$$${safe}$$` : `$${safe}$`;
  }
};
